/**
 *   Created by wangyuelong on 2018/9/28
 */
import _ from 'lodash';
import cookies from 'js-cookie';
import qblogin from '@tencent/qblogin';
import { user as service } from '../fetchers';
import { update } from './user';
// import { setDistributeStatus } from './article';
import { type Dispatch } from './types';

// let canLogin = true;

export const makeauthenticate = (userInfo = {}) => async (dispatch: Dispatch) => {
  if (userInfo && !_.isEmpty(userInfo)) {
    await dispatch(
      update({
        ...userInfo,
        roleInCircle: userInfo.userRole || 0,
        circleUserId: userInfo.qbid || 0,
        type: 5,
        qbUserType: userInfo.type || 0,
      }),
    );
  }
  if (!userInfo.sa || !userInfo.sk) {
    await service.logout();
  } else {
    const { userRole, qbid } = userInfo || {};
    const cUser = `5:${qbid}`;
    cookies.set('c_user', cUser);
    cookies.set('c_userRole', userRole);
    await service.sendAuthenticate(userInfo);
  }
};

export const authenticate = async () => {
  // 始终以终端返回的用户信息为准
  const user = (await qblogin.getSession()) || {};
  const userInfo = {
    ...user,
    roleInCircle: user.userRole || 0,
    circleUserId: user.qbid || 0,
    type: 5,
    qbUserType: user.type || 0,
  };
  return userInfo;
};
